module.exports = __webpack_public_path__ + "img/shape-1@2x.b5fd473d.png";